// Utility to suppress ResizeObserver errors
// These errors are benign and occur when ResizeObserver cannot deliver all observations within a single animation frame

export const suppressResizeObserverError = () => {
  // Store the original error handler
  const originalError = window.onerror;
  const originalUnhandledRejection = window.onunhandledrejection;

  // Override window.onerror
  window.onerror = function (message, source, lineno, colno, error) {
    if (
      typeof message === "string" &&
      (message.includes(
        "ResizeObserver loop completed with undelivered notifications",
      ) ||
        message.includes("ResizeObserver loop limit exceeded"))
    ) {
      // Suppress the error
      return true;
    }
    // Call the original error handler if it exists
    if (originalError) {
      return originalError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Also handle unhandled promise rejections that might contain ResizeObserver errors
  window.onunhandledrejection = function (event) {
    if (
      event.reason &&
      event.reason.message &&
      (event.reason.message.includes(
        "ResizeObserver loop completed with undelivered notifications",
      ) ||
        event.reason.message.includes("ResizeObserver loop limit exceeded"))
    ) {
      // Suppress the error
      event.preventDefault();
      return true;
    }
    // Call the original handler if it exists
    if (originalUnhandledRejection) {
      return originalUnhandledRejection.call(window, event);
    }
    return false;
  };

  // For React's error boundaries in development
  if (import.meta.env.DEV) {
    const resizeObserverErrorHandler = (e: ErrorEvent) => {
      if (
        e.error &&
        e.error.message &&
        (e.error.message.includes(
          "ResizeObserver loop completed with undelivered notifications",
        ) ||
          e.error.message.includes("ResizeObserver loop limit exceeded"))
      ) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();
        return true;
      }
    };

    // Use capture phase to catch errors early
    window.addEventListener("error", resizeObserverErrorHandler, true);
  }
};
